import styles from './slider.module.scss';
import cn from 'classnames';

interface CarouselSkeletonProps {
    count?: number;
    className?: string;
}

export default function CarouselSkeleton({ count = 3, className }: CarouselSkeletonProps): React.JSX.Element {
    return (
        <div className={cn(styles.slider, styles.skeleton, styles.ContentShowcase, className)}>
            <div className={styles.sliderTrack}>
                {Array.from({ length: count }).map((_, i) => (
                    <div className={styles.skeletonSlide} key={i}>
                        <div className={styles.skeletonImage} />
                        <div className={styles.skeletonText} />
                        <div className={styles.skeletonText} />
                    </div>
                ))}
            </div>
            <div className={styles.skeletonPagination}>
                {Array.from({ length: count }).map((_, i) => (
                    <div className={styles.skeletonPaginationPage} key={i}></div>
                ))}
            </div>
        </div>
    );
}
